import { render, staticRenderFns } from "./SearchCount.vue?vue&type=template&id=3084fb7e&scoped=true"
import script from "./SearchCount.vue?vue&type=script&lang=ts"
export * from "./SearchCount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3084fb7e",
  null
  
)

export default component.exports